<template>
  <div class="incentives-container">
    <h1>Incentives</h1>
    <table>
      <thead>
        <tr>
          <th v-for="header in headers" :key="header.text">
            {{ header.text }}
            <span v-if="filterable.includes(header.value)" @click="showFilter = !showFilter">
              <img src="./assets/filter.png" alt="Filter" class="filter-icon" />
            </span>
            <span v-if="header.value === 'timeLeft'" @click="showTimeFilter = !showTimeFilter">
              <img src="./assets/filter.png" alt="Filter" class="filter-icon" />
            </span>


            <div v-if="showFilter && header.value === 'status'" class="filter-dropdown">
              <div>
                <input type="checkbox" id="open" value="Open" v-model="selectedStatus" />
                <label for="open">Open</label>
              </div>
              <div>
                <input type="checkbox" id="closed" value="Closed" v-model="selectedStatus" />
                <label for="closed">Closed</label>
              </div>
            </div>
            <div v-if="showTimeFilter && header.value === 'timeLeft'" class="filter-dropdown">
              <div @click="sortTime('desc')">Most to Least</div>
              <div @click="sortTime('asc')">Least to Most</div>
            </div>

          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="incentive in filteredIncentives" :key="incentive.id">
          <td>{{ incentive.id }}</td>
          <td>{{ incentive.type }}</td>
          <td>{{ incentive.name }}</td>
          <td>{{ incentive.status }}</td>
          <td>{{ incentive.timeLeft }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'IncentivesTable',
  data() {
    return {
      incentives: [
        { id: '0x1', type: 'Bounty', name: 'Bounty 1', status: 'Closed', timeLeft: '00:00:00' },
        { id: '0x2', type: 'Bounty', name: 'Bounty 2', status: 'Open', timeLeft: '00:20:18' },
        { id: '0x3', type: 'Bounty', name: 'Bounty 3', status: 'Open', timeLeft: '15:09:20' },
      ],
      filterable: ['status'], // Specify only 'status' as a filterable field for simplicity.
      selectedStatus: ['Open', 'Closed'], // By default, both are selected.
      showFilter: false,
      showTimeFilter: false,
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Type', value: 'type' },
        { text: 'Name', value: 'name' },
        { text: 'Status', value: 'status' },
        { text: 'Time Left', value: 'timeLeft' }
      ],
      sortKey: ''
    };
  },
  computed: {
    filteredIncentives() {
      return this.incentives.filter(incentive => {
        return this.selectedStatus.includes(incentive.status);
      });
    }
  },
  methods: {
    // ...
    sortTime(order) {
      this.showTimeFilter = false; // Close the dropdown
      if (order === 'asc') {
        this.incentives.sort((a, b) => this.timeToSeconds(a.timeLeft) - this.timeToSeconds(b.timeLeft));
      } else {
        this.incentives.sort((a, b) => this.timeToSeconds(b.timeLeft) - this.timeToSeconds(a.timeLeft));
      }
    },
    timeToSeconds(time) {
      const [hours, minutes, seconds] = time.split(':').map(t => parseInt(t, 10));
      return hours * 3600 + minutes * 60 + seconds;
    }
  }

};
</script>

<style scoped>
.incentives-container {
  margin-top: 50px;
  
  text-align: center;
  border-radius: 2%;
}

.incentives-container h1 {
  color: #000000;
}

.incentives-container table {
  width: 100%;
  margin-top: 20px;
  border-collapse: separate;
  border-spacing: 0;
}

.incentives-container th, .incentives-container td {
  border: .05px solid rgb(155, 155, 155);
  padding: 15px;
  text-align: left;
}

.incentives-container th span {
  cursor: pointer;
  margin-left: 10px;
  user-select: none;
}

.incentives-container thead th {
  background-color: #d3d3d3;
}

.filter-dropdown {
  position: absolute;
  background-color: #f9f9f9;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
}

.filter-dropdown div {
  padding: 12px 16px;
  cursor: pointer;
  user-select: none;
}
.filter-icon {
    width: 16px; /* or the size you want */
    height: 16px; /* or the size you want */
    cursor: pointer;
  }
</style>
